export const langs = [
  "de",
  "en",
  "pl",
  "ro",
  "ru",
  "sr",
  "tr"
];
